export class EmptyStringToNullValueConverter {
  fromView(value) {
    if (value.trim() === '') {
        return null;
    }
    return value;
  }
}
